// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item[data-v-c0691be0]{width:100%;margin:.5em 0;display:flex;align-items:center}.form-item .icon[data-v-c0691be0]{height:44px;margin-right:1em}.form-item .input-wrapper[data-v-c0691be0]{width:100%}.form-item .input-wrapper[data-v-c0691be0] .textarea{resize:vertical}.form-item .input-wrapper[data-v-c0691be0] .input,.form-item .input-wrapper[data-v-c0691be0] .textarea{display:block;width:100%;flex:0}\n", ""]);
// Exports
module.exports = exports;
